export function packageMass(text) {
  // Prefer explicitly stated metric mass over rounded customary equivalents.
  const value = String(text || "");
  const metric = value.match(/(\d+(?:\.\d+)?)\s*(kg|g)\b/i);
  if (metric) return Number(metric[1]) * (metric[2].toLowerCase() === "kg" ? 1000 : 1);
  if (/fl\s*oz|\bml\b|\bl\b/i.test(value)) return null;
  const customary = value.match(/(\d+(?:\.\d+)?)\s*(oz|lb)\b/i);
  return customary ? Number(customary[1]) * (customary[2].toLowerCase() === "lb" ? 453.59237 : 28.349523125) : null;
}
// Counts use the current package and serving masses, never an older API result.
// This does not determine FDA single-serving/dual-column package eligibility.
export function containerServings(netGrams, servingGrams) {
  const net = Number(netGrams), serving = Number(servingGrams);
  if (!Number.isFinite(net) || !Number.isFinite(serving) || net <= 0 || serving <= 0) return null;
  const raw = net / serving;
  const value = Math.max(1, raw >= 2 && raw <= 5 ? Math.round(raw * 2) / 2 : Math.round(raw));
  const about = Math.abs(raw - value) > 1e-9;
  return { raw, value, about, display: `${about ? "about " : ""}${value} ${value === 1 ? "serving" : "servings"} per container` };
}